'use strict'

import { CHECKOUT } from "../constants/ActionTypes"

const initialCheckoutState = {
    CHECKOUT_PUBLIC_DATA: null,
    CHECKOUT_DEFAULT_ADDRESS: null,
    CHECKOUT_ORDER_ID: null,
    CHECKOUT_INFORMATION: null,
    CHECKOUT_CHANGE_PAYMENT: null,
    CHECKOUT_CHANGE_RECEIVING: null,
    CHECKOUT_TAB_GUESSYOULIKE: null,
    CHECKOUT_TAB_MYFAVORITE: null,
    CHECKOUT_TAB_MYBROWSERHISTORY: null,
    CHECKOUT_TAB_LIST: [],
    CHECKOUT_DELETE_POSITION_FIRST: null,
    CHECKOUT_DELETE_POSITION_SECOND: null,
    CHECKOUT_DELETE_POSITION_THIRD: null,
    CHECKOUT_ORDER_TYPE: null,
    CHECKOUT_DELIVERY_INFO: 1,
    CHECKOUT_ADDRESS_COD: null,
    CHECKOUT_ADDRESS_EXPRESS: null,
    CHECKOUT_PURCHASED: null,
    SET_CHECKOUT_GIFT: null,
    CHECKOUT_CARTINFO: null,
    CHECKOUT_ALERT: null,
    CHECKOUT_NOTICE: null,
    CHECKOUT_DELETE_ITEM: null,
    CHECKOUT_GET_SKU_STANDARD: null,
    CHECKOUT_SAVE_ALL_SKU: null,
    CHECKOUT_SAVE_TOTAL_DELETE: null,
    CHECKOUT_COLLECT_ITEM_ALL_LIST: null,
    CHECKOUT_ORDER_INFORMATION: null,
    PXCOUPONS: null,
    PROMOTIONCODEMAP: null,
    CHECKOUT_PAY_LINK: null,
    CHECKOUT_THIRD_ALERT_PAY: null,
    CHECKOUT_ORDER_STATUS: null,
    CHECKOUT_POSITION_DELETE: null,
    ORDER_DETAIL: null,
    CHECKOUT_SELECT_TAB: null,
    CHECKOUT_SAVE_ALL_SKU_LOSE: null,
    CONTROL: 'none',
    CHECKOUT_MISS_SKUID: [],
    CHECKOUT_CORRESPOND_SKUID: [],
    CHECKOUT_CORRESPOND_SKUID_BOOKING: [],
    CHECKOUT_RESERVE_DATA: null,
    CHECKOUT_SINGLE_SKUID: [],
    CHECKOUT_SINGLE_SKUID_BOOKING: [],
    CHECKOUT_RESERVE_SINGLE_DATA: null,
    CHECKOUT_CARTINFO_BOOKING: null,
    CHECKOUT_CHANGE_STATE: 0,
    CHECKOUT_CHANGE_STATE_AGREEMENT: 0,
    SATISFYGIFTCOMMENTS: "",
    CHECKOUT_PHONE_DATA: null,
    CHECKOUT_INPUTCOUPONS: null,
    CHECKOUT_ALL_GIFT: null,
    CHECKOUT_ALL_GIFT_BOOKING: null,
    CHECKOUT_ORDER_DETAILS: null,
    CHECKOUT_MISS_SKUID_BOOKING: [],
    CHECKOUT_RESERVE_PROMOTION_DATA: null,
    CHECKOUT_ADDRESS_LIST: null,
    CHECKOUT_PHONE_STATUS: null,
    CHECKOUT_CUR_STATUS: null,
    CHECKOUT_CUR_TYPE: null,
    CHECKOUT_ATTR_STATUS: null,
    CHECKOUT_GOODS_STATUS: false,
    CHECKOUT_SILK_CARD_LIST: null,
    CHECKOUT_URL_PARMTER: null,
    CHECKOUT_GET_ORDER_STATUS: null,
    CHECKOUT_SILK_PAY_ONOFF: null,
    CHECKOUT_CHANGE_TAB_SORT: false,
    CHECKOUT_CART_TIME_STAMP: false,
    CHECKOUT_TIMEING_CHECKED: 0,
    CHECKOUT_REMEMBER_CHOOSE: null,
    CHECKOUT_KEEP_PARAMETER: null,
    CHECKOUT_SAVE_PARAMETER: null,
    GETOPTIONALGIFT: [],
    CHECKOUT_INVOICE_STATUS: 'N',
    CHECKOUT_INVOICE_INDIVIDUAL_SAVE: false,
    CHECKOUT_INVOICE_ENTERPRISE_SAVE: false,
    CHECKOUT_INVOICE_ENTERPRISE_OPEN: false,
    CHECKOUT_INVOICE_DEFAULTTITLE: {},
    CHECKOUT_INVOICE_TITLEID: 0,
    CHECKOUT_INVOICE_DATA: {},
    CHECKOUT_GOODS_STATUS: "",
    DEPOSIT_COMMENT: "",
    CANCEL_ORDER_TIME_LEFT: "",
    SHOULDPAY: "",
    EXTRABUYACTID: "",
    EXTRABUYTITLE: "",
    EXCHANGEPRODUCTLIST: [],
    CART_TIPSMSG: "",
    DELETEPRODUCTTYPE: ""
}
export default function (state = initialCheckoutState, action = {}) {
    let CHECKOUT_SAVE_PARAMETER = action.CHECKOUT_SAVE_PARAMETER;
    let CHECKOUT_KEEP_PARAMETER = action.CHECKOUT_KEEP_PARAMETER;
    let CHECKOUT_REMEMBER_CHOOSE = action.CHECKOUT_REMEMBER_CHOOSE;
    let CHECKOUT_TIMEING_CHECKED = action.CHECKOUT_TIMEING_CHECKED;
    let CHECKOUT_CART_TIME_STAMP = action.CHECKOUT_CART_TIME_STAMP;
    let CHECKOUT_CHANGE_TAB_SORT = action.CHECKOUT_CHANGE_TAB_SORT;
    let CHECKOUT_ATTR_STATUS = action.CHECKOUT_ATTR_STATUS;
    let CHECKOUT_CUR_TYPE = action.CHECKOUT_CUR_TYPE;
    let CHECKOUT_CUR_STATUS = action.CHECKOUT_CUR_STATUS;
    let CHECKOUT_PHONE_STATUS = action.CHECKOUT_PHONE_STATUS;
    let CHECKOUT_ADDRESS_LIST = action.CHECKOUT_ADDRESS_LIST;
    let CHECKOUT_MISS_SKUID_BOOKING = action.CHECKOUT_MISS_SKUID_BOOKING;
    let CHECKOUT_ORDER_DETAILS = action.CHECKOUT_ORDER_DETAILS;
    let CHECKOUT_ALL_GIFT = action.CHECKOUT_ALL_GIFT;
    let CHECKOUT_ALL_GIFT_BOOKING = action.CHECKOUT_ALL_GIFT_BOOKING;
    let CHECKOUT_INPUTCOUPONS = action.CHECKOUT_INPUTCOUPONS;
    let CHECKOUT_PHONE_DATA = action.CHECKOUT_PHONE_DATA;
    let CHECKOUT_CHANGE_STATE = action.CHECKOUT_CHANGE_STATE;
    let SATISFYGIFTCOMMENTS = action.SATISFYGIFTCOMMENTS;
    let CHECKOUT_ORDER_TYPE = action.CHECKOUT_ORDER_TYPE;
    let CHECKOUT_PUBLIC_DATA = action.CHECKOUT_GET;
    let CHECKOUT_DEFAULT_ADDRESS = action.CHECKOUT_DEFAULT_ADDRESS;
    let CHECKOUT_ORDER_ID = action.CHECKOUT_ORDER_ID;
    let CHECKOUT_INFORMATION = action.CHECKOUT_INFORMATION;
    let CHECKOUT_CHANGE_PAYMENT = action.CHECKOUT_CHANGE_PAYMENT;
    let CHECKOUT_CHANGE_RECEIVING = action.CHECKOUT_CHANGE_RECEIVING;
    let CHECKOUT_PAY_LINK = action.CHECKOUT_PAY_LINK;
    let CHECKOUT_TAB_GUESSYOULIKE = action.CHECKOUT_TAB_GUESSYOULIKE;
    let CHECKOUT_TAB_MYFAVORITE = action.CHECKOUT_TAB_MYFAVORITE;
    let CHECKOUT_TAB_MYBROWSERHISTORY = action.CHECKOUT_TAB_MYBROWSERHISTORY;
    let CHECKOUT_TAB_ACTIVE = action.CHECKOUT_TAB_ACTIVE;
    let CHECKOUT_DELETE_POSITION_FIRST = action.CHECKOUT_DELETE_POSITION_FIRST;
    let CHECKOUT_DELETE_POSITION_SECOND = action.CHECKOUT_DELETE_POSITION_SECOND;
    let CHECKOUT_DELETE_POSITION_THIRD = action.CHECKOUT_DELETE_POSITION_THIRD;
    let CHECKOUT_DELIVERY_INFO = action.CHECKOUT_DELIVERY_INFO;
    let CHECKOUT_ADDRESS_COD = action.CHECKOUT_ADDRESS_COD;
    let CHECKOUT_ADDRESS_EXPRESS = action.CHECKOUT_ADDRESS_EXPRESS;
    let CHECKOUT_PURCHASED = action.CHECKOUT_PURCHASED;
    let SET_CHECKOUT_GIFT = action.SET_CHECKOUT_GIFT;


    let CHECKOUT_SAVE_ALERT_DATA_ID = action.CHECKOUT_SAVE_ALERT_DATA_ID;
    let CHECKOUT_SAVE_ALERT_DATA_TYPE = action.CHECKOUT_SAVE_ALERT_DATA_TYPE;
    let CHECKOUT_SAVE_ALERT_DATA_TEXT = action.CHECKOUT_SAVE_ALERT_DATA_TEXT;
    let CHECKOUT_SAVE_ALERT_DATA_NAME = action.CHECKOUT_SAVE_ALERT_DATA_NAME;
    let CHECKOUT_SAVE_ALERT_DATA_PRODUCT_TYPE = action.CHECKOUT_SAVE_ALERT_DATA_PRODUCT_TYPE;
    let CHECKOUT_SAVE_ALERT_DATA_QUANTITY = action.CHECKOUT_SAVE_ALERT_DATA_QUANTITY;
    let CHECKOUT_SAVE_ALERT_DATA_ACTIONTYPE = action.CHECKOUT_SAVE_ALERT_DATA_ACTIONTYPE;

    let CHECKOUT_NOTICE_ID = action.CHECKOUT_NOTICE_ID;

    let CHECKOUT_ADD_REMOVE_ID = action.CHECKOUT_ADD_REMOVE_ID;
    let CHECKOUT_ADD_REMOVE_NAME = action.CHECKOUT_ADD_REMOVE_NAME;
    let CHECKOUT_ADD_REMOVE_TYPE = action.CHECKOUT_ADD_REMOVE_TYPE;
    let CHECKOUT_ADD_REMOVE_QUANTITY = action.CHECKOUT_ADD_REMOVE_QUANTITY;
    let CHECKOUT_ADD_REMOVE_STATUS = action.CHECKOUT_ADD_REMOVE_STATUS;
    let CHECKOUT_ADD_REMOVE_INVENTORY = action.CHECKOUT_ADD_REMOVE_INVENTORY;
    let CHECKOUT_ADD_REMOVE_PRODUCTID = action.CHECKOUT_ADD_REMOVE_PRODUCTID;
    let CHECKOUT_ADD_REMOVE_OFFERPRICE = action.CHECKOUT_ADD_REMOVE_OFFERPRICE;
    let CHECKOUT_ADD_REMOVE_SKUCODE = action.CHECKOUT_ADD_REMOVE_SKUCODE;
    let CHECKOUT_ADD_REMOVE_PRODUCTNAMEEN = action.CHECKOUT_ADD_REMOVE_PRODUCTNAMEEN;
    let CHECKOUT_ADD_REMOVE_DELETEPRODUCTTYPE = action.CHECKOUT_ADD_REMOVE_DELETEPRODUCTTYPE;
    let CHECKOUT_GET_SKU_STANDARD = action.CHECKOUT_GET_SKU_STANDARD;

    let CHECKOUT_SAVE_ALL_SKU_TEXT = action.CHECKOUT_SAVE_ALL_SKU_TEXT;
    let CHECKOUT_SAVE_ALL_SKU_LIST = action.CHECKOUT_SAVE_ALL_SKU_LIST;


    let CHECKOUT_COLLECT_ITEM_ALL_TEXT = action.CHECKOUT_COLLECT_ITEM_ALL_TEXT;
    let CHECKOUT_COLLECT_ITEM_ALL_LIST = action.CHECKOUT_COLLECT_ITEM_ALL_LIST;

    let CHECKOUT_SAVE_TOTAL_DELETE = action.CHECKOUT_SAVE_TOTAL_DELETE;

    //let CHECKOUT_CLEAR_LOSE_SKU = action.CHECKOUT_CLEAR_LOSE_SKU;

    //购物车第二布订单数据
    let CHECKOUT_ORDER_INFORMATION = action.CHECKOUT_ORDER_INFORMATION;
    let PXCOUPONS = action.PXCOUPONS;
    let PROMOTIONCODEMAP = action.PROMOTIONCODEMAP;
    //购物车数据
    let CHECKOUT_CARTINFO = action.CHECKOUT_CARTINFO;
    //定金预售数据
    let CHECKOUT_CARTINFO_BOOKING = action.CHECKOUT_CARTINFO_BOOKING;
    //third
    let CHECKOUT_GET_ORDER_STATUS = action.CHECKOUT_GET_ORDER_STATUS;

    //orderdetail
    let ORDER_DETAIL = action.ORDER_DETAIL;


    let CHECKOUT_TAB_LIST,
        CHECKOUT_TAB_LIST_OBJECT,
        CHECKOUT_TAB_ACTIVE_OBJECT;
    //取前台传来的数据
    let CHECKOUT_SAVE_ALL_SKU_LOSE_LIST = action.CHECKOUT_SAVE_ALL_SKU_LOSE;
    //控制清除失效商品按钮
    let CHECKOUT_MISS_SKUID = action.CHECKOUT_MISS_SKUID;
    //商品关联对应赠品数据(组增) 向接口发送的入参数据
    let CHECKOUT_CORRESPOND_SKUID = action.CHECKOUT_CORRESPOND_SKUID;

    let CHECKOUT_CORRESPOND_SKUID_BOOKING = action.CHECKOUT_CORRESPOND_SKUID_BOOKING;
    //储存组增接口返回数据
    let CHECKOUT_RESERVE_DATA = action.CHECKOUT_RESERVE_DATA;
    //商品关联对应赠品数据(单赠) 向接口发送的入参数据
    let CHECKOUT_SINGLE_SKUID = action.CHECKOUT_SINGLE_SKUID;
    let CHECKOUT_SINGLE_SKUID_BOOKING = action.CHECKOUT_SINGLE_SKUID_BOOKING;
    //储存单增接口返回数据
    let CHECKOUT_RESERVE_SINGLE_DATA = action.CHECKOUT_RESERVE_SINGLE_DATA;
    //储存订单级别接口返回数据
    let CHECKOUT_RESERVE_PROMOTION_DATA = action.CHECKOUT_RESERVE_PROMOTION_DATA;
    //记录定金预商品状态
    let CHECKOUT_GOODS_STATUS = action.CHECKOUT_GOODS_STATUS;
    //存储丝享卡列表信息
    let CHECKOUT_SILK_CARD_LIST = action.CHECKOUT_SILK_CARD_LIST;
    //丝享卡支付入参
    let CHECKOUT_URL_PARMTER = action.CHECKOUT_URL_PARMTER;
    //silk on off
    let CHECKOUT_SILK_PAY_ONOFF = action.CHECKOUT_SILK_PAY_ONOFF;

    // 组赠自选数据
    let GETOPTIONALGIFT = action.GETOPTIONALGIFT;

    // 是否开具电子发票
    let CHECKOUT_INVOICE_STATUS = action.CHECKOUT_INVOICE_STATUS;
    // 保存个人抬头信息
    let CHECKOUT_INVOICE_INDIVIDUAL_SAVE = action.CHECKOUT_INVOICE_INDIVIDUAL_SAVE;
    // 保存企业抬头信息
    let CHECKOUT_INVOICE_ENTERPRISE_SAVE = action.CHECKOUT_INVOICE_ENTERPRISE_SAVE;
    // 展开选填
    let CHECKOUT_INVOICE_ENTERPRISE_OPEN = action.CHECKOUT_INVOICE_ENTERPRISE_OPEN;
    // 默认抬头信息 
    let CHECKOUT_INVOICE_DEFAULTTITLE = action.CHECKOUT_INVOICE_DEFAULTTITLE;
    // 抬头id
    let CHECKOUT_INVOICE_TITLEID = action.CHECKOUT_INVOICE_TITLEID;
    // 输入的抬头信息
    let CHECKOUT_INVOICE_DATA = action.CHECKOUT_INVOICE_DATA;
    let DEPOSIT_COMMENT = action.DEPOSIT_COMMENT; //定金预售 付定金备注
    let CANCEL_ORDER_TIME_LEFT = action.CANCEL_ORDER_TIME_LEFT;
    let EXTRABUYACTID = action.EXTRABUYACTID;
    let CART_TIPSMSG = action.CART_TIPSMSG;
    let EXTRABUYTITLE = action.EXTRABUYTITLE;
    let EXTRALBUYSHOWSTATUS = action.EXTRALBUYSHOWSTATUS;
    let EXCHANGEPRODUCTLIST = action.EXCHANGEPRODUCTLIST;
    let SHOULDPAY = action.SHOULDPAY;
    let DELETEPRODUCTTYPE = action.DELETEPRODUCTTYPE;
    switch (action.type) {
        case CHECKOUT.CHECKOUT_SAVE_PARAMETER:
            return Object.assign({}, state, {
                CHECKOUT_SAVE_PARAMETER,
            });
            break;
        case CHECKOUT.CHECKOUT_KEEP_PARAMETER:
            return Object.assign({}, state, {
                CHECKOUT_KEEP_PARAMETER,
            });
            break;
        case CHECKOUT.CHECKOUT_REMEMBER_CHOOSE:
            return Object.assign({}, state, {
                CHECKOUT_REMEMBER_CHOOSE,
            });
            break;
        case CHECKOUT.CHECKOUT_TIMEING_CHECKED:
            return Object.assign({}, state, {
                CHECKOUT_TIMEING_CHECKED,
            });
            break;
        case CHECKOUT.CHECKOUT_CART_TIME_STAMP:
            return Object.assign({}, state, {
                CHECKOUT_CART_TIME_STAMP,
            });
            break;
        case CHECKOUT.CHECKOUT_CHANGE_TAB_SORT:
            return Object.assign({}, state, {
                CHECKOUT_CHANGE_TAB_SORT,
            });
            break;
        case CHECKOUT.CHECKOUT_SILK_PAY_ONOFF:
            return Object.assign({}, state, {
                CHECKOUT_SILK_PAY_ONOFF,
            });
            break;
        case CHECKOUT.CHECKOUT_GOODS_STATUS:
            return Object.assign({}, state, {
                CHECKOUT_GOODS_STATUS,
            });
            break;
        case CHECKOUT.CHECKOUT_ATTR_STATUS:
            return Object.assign({}, state, {
                CHECKOUT_ATTR_STATUS,
            });
            break;
        case CHECKOUT.CHECKOUT_CUR_STATUS:
            return Object.assign({}, state, {
                CHECKOUT_CUR_STATUS,
                CHECKOUT_CUR_TYPE
            });
            break;
        case CHECKOUT.CHECKOUT_PHONE_STATUS:
            return Object.assign({}, state, {
                CHECKOUT_PHONE_STATUS
            });
            break;
        case CHECKOUT.CHECKOUT_ADDRESS_LIST:
            return Object.assign({}, state, {
                CHECKOUT_ADDRESS_LIST
            });
            break;
        case CHECKOUT.CHECKOUT_RESERVE_PROMOTION_DATA:
            return Object.assign({}, state, {
                CHECKOUT_RESERVE_PROMOTION_DATA
            });
            break;
        case CHECKOUT.CHECKOUT_MISS_SKUID_BOOKING:
            return Object.assign({}, state, {
                CHECKOUT_MISS_SKUID_BOOKING
            });
            break;
        case CHECKOUT.CHECKOUT_ORDER_DETAILS:
            return Object.assign({}, state, {
                CHECKOUT_ORDER_DETAILS
            });
            break;
        case CHECKOUT.CHECKOUT_ALL_GIFT:
            return Object.assign({}, state, {
                CHECKOUT_ALL_GIFT
            });
            break;

        case CHECKOUT.CHECKOUT_ALL_GIFT_BOOKING:
            return Object.assign({}, state, {
                CHECKOUT_ALL_GIFT_BOOKING
            });
            break;

        case CHECKOUT.CHECKOUT_INPUTCOUPONS:
            return Object.assign({}, state, {
                CHECKOUT_INPUTCOUPONS
            });
            break;
        case CHECKOUT.CHECKOUT_PHONE_DATA:
            return Object.assign({}, state, {
                CHECKOUT_PHONE_DATA
            });
            break;
        case CHECKOUT.DEPOSIT_COMMENT:
            return Object.assign({}, state, {
                DEPOSIT_COMMENT
            });
            break;
        case CHECKOUT.CANCEL_ORDER_TIME_LEFT:
            return Object.assign({}, state, {
                CANCEL_ORDER_TIME_LEFT
            });
            break;
        case CHECKOUT.SHOULDPAY:
            return Object.assign({}, state, {
                SHOULDPAY
            });
            break;

        case CHECKOUT.CHECKOUT_CHANGE_STATE_AGREEMENT:
            return Object.assign({}, state, {
                CHECKOUT_CHANGE_STATE_AGREEMENT: action.CHECKOUT_CHANGE_STATE_AGREEMENT
            });
            break;
        case CHECKOUT.SATISFYGIFTCOMMENTS:
            return Object.assign({}, state, {
                SATISFYGIFTCOMMENTS: action.SATISFYGIFTCOMMENTS
            });
            break;

        case CHECKOUT.CHECKOUT_CHANGE_STATE:
            return Object.assign({}, state, {
                CHECKOUT_CHANGE_STATE
            });
            break;

        case CHECKOUT.CHECKOUT_ORDER_TYPE:
            return Object.assign({}, state, {
                CHECKOUT_ORDER_TYPE
            });
            break;

        case CHECKOUT.CHECKOUT_RESERVE_SINGLE_DATA:
            return Object.assign({}, state, {
                CHECKOUT_RESERVE_SINGLE_DATA
            });
            break;

        case CHECKOUT.CHECKOUT_SINGLE_SKUID:
            return Object.assign({}, state, {
                CHECKOUT_SINGLE_SKUID
            });
            break;

        case CHECKOUT.CHECKOUT_SINGLE_SKUID_BOOKING:
            return Object.assign({}, state, {
                CHECKOUT_SINGLE_SKUID_BOOKING
            });
            break;
        case CHECKOUT.CHECKOUT_RESERVE_DATA:
            return Object.assign({}, state, {
                CHECKOUT_RESERVE_DATA
            });
            break;

        case CHECKOUT.CHECKOUT_MISS_SKUID:
            return Object.assign({}, state, {
                CHECKOUT_MISS_SKUID
            });
            break;

        case CHECKOUT.CHECKOUT_CORRESPOND_SKUID:
            return Object.assign({}, state, {
                CHECKOUT_CORRESPOND_SKUID
            });
            break;
        case CHECKOUT.CHECKOUT_CORRESPOND_SKUID_BOOKING:
            return Object.assign({}, state, {
                CHECKOUT_CORRESPOND_SKUID_BOOKING
            });
            break;
        case CHECKOUT.CONTROL:
            return Object.assign({}, state, {
                CONTROL: action.item
            });
            break;

        case CHECKOUT.CHECKOUT_SELECT_TAB:
            return Object.assign({}, state, {
                CHECKOUT_SELECT_TAB: action.value
            });
            break;
        case CHECKOUT.ORDER_DETAIL:
            return Object.assign({}, state, {
                ORDER_DETAIL
            });
            break;
        case CHECKOUT.CHECKOUT_CLEAR_POSITION_DELETE:
            return Object.assign({}, state, {
                CHECKOUT_POSITION_DELETE: null
            });
            break;
        case CHECKOUT.CHECKOUT_GET_ORDER_STATUS:
            return Object.assign({}, state, {
                CHECKOUT_ORDER_STATUS: CHECKOUT_GET_ORDER_STATUS
            });
            break;
        case CHECKOUT.CHECKOUT_CLOSE_THIRD_ALERT_PAY:
            return Object.assign({}, state, {
                CHECKOUT_THIRD_ALERT_PAY: null
            });
            break;
        case CHECKOUT.CHECKOUT_OPEN_THIRD_ALERT_PAY:
            return Object.assign({}, state, {
                CHECKOUT_THIRD_ALERT_PAY: 1
            });
            break;
        case CHECKOUT.CHECKOUT_ORDER_INFORMATION:
            return Object.assign({}, state, {
                CHECKOUT_ORDER_INFORMATION
            });
            break;
        case CHECKOUT.PXCOUPONS:
            return Object.assign({}, state, {
                PXCOUPONS
            });
            break;
        case CHECKOUT.PROMOTIONCODEMAP:
            return Object.assign({}, state, {
                PROMOTIONCODEMAP
            });
            break;

        case CHECKOUT.CHECKOUT_SAVE_ALL_SKU_LOSE:
            /*let clearAllItem = {
                status:'3',
                text : CHECKOUT_CLEAR_LOSE_SKU
            };
            return Object.assign({},state,{
                CHECKOUT_ALERT:clearAllItem
            }); */
            return Object.assign({}, state, {
                CHECKOUT_ALERT: action.param,
                CHECKOUT_SAVE_ALL_SKU_LOSE: CHECKOUT_SAVE_ALL_SKU_LOSE_LIST
            });
            break;
        case CHECKOUT.CHECKOUT_COLLECT_ITEM_ALL:
            let collectItem = {
                status: '2',
                text: CHECKOUT_COLLECT_ITEM_ALL_TEXT
            };
            return Object.assign({}, state, {
                CHECKOUT_ALERT: collectItem,
                CHECKOUT_COLLECT_ITEM_ALL_LIST: CHECKOUT_COLLECT_ITEM_ALL_LIST

            });
            break;
        case CHECKOUT.CHECKOUT_SAVE_TOTAL_DELETE:
            return Object.assign({}, state, {
                CHECKOUT_SAVE_TOTAL_DELETE: CHECKOUT_SAVE_TOTAL_DELETE,
                CHECKOUT_POSITION_DELETE: 1
            });
            break;
        case CHECKOUT.CHECKOUT_SAVE_ALL_SKU:
            /*let removeAllSkuAlert = {
                status:'1',
                text : CHECKOUT_SAVE_ALL_SKU_TEXT
            };*/
            /*return Object.assign({},state,{
                CHECKOUT_ALERT: removeAllSkuAlert,
                CHECKOUT_SAVE_ALL_SKU: CHECKOUT_SAVE_ALL_SKU_LIST
            });*/
            return Object.assign({}, state, {
                CHECKOUT_ALERT: action.param,
                CHECKOUT_SAVE_ALL_SKU: CHECKOUT_SAVE_ALL_SKU_LIST
            });
            break;
        case CHECKOUT.CHECKOUT_GET_SKU_STANDARD:
            return Object.assign({}, state, {
                CHECKOUT_GET_SKU_STANDARD
            });
            break;
        case CHECKOUT.CHECKOUT_CLEAR_SKU_STANDARD:
            return Object.assign({}, state, {
                CHECKOUT_GET_SKU_STANDARD: null
            });
            break;
        case CHECKOUT.CHECKOUT_CLOSE_DELETE:
            return Object.assign({}, state, {
                CHECKOUT_DELETE_ITEM: null,
                CHECKOUT_SAVE_TOTAL_DELETE: null,
                CHECKOUT_POSITION_DELETE: null
            });
            break;
        case CHECKOUT.CHECKOUT_ADD_REMOVE:
            let checkoutFirstDeleteItem = {};
            checkoutFirstDeleteItem = {
                channel: 'PC',
                skuId: CHECKOUT_ADD_REMOVE_ID,
                productName: CHECKOUT_ADD_REMOVE_NAME,
                type: CHECKOUT_ADD_REMOVE_TYPE,
                quantity: CHECKOUT_ADD_REMOVE_QUANTITY,
                status: CHECKOUT_ADD_REMOVE_STATUS,
                inventory: CHECKOUT_ADD_REMOVE_INVENTORY,
                productId: CHECKOUT_ADD_REMOVE_PRODUCTID,
                offerPrice: CHECKOUT_ADD_REMOVE_OFFERPRICE,
                skuCode: CHECKOUT_ADD_REMOVE_SKUCODE,
                productNameEN: CHECKOUT_ADD_REMOVE_PRODUCTNAMEEN,
                deleteProductType: CHECKOUT_ADD_REMOVE_DELETEPRODUCTTYPE
            };
            return Object.assign({}, state, {
                CHECKOUT_DELETE_ITEM: checkoutFirstDeleteItem,
                CHECKOUT_POSITION_DELETE: 1
            });
            break;
        case CHECKOUT.CHECKOUT_NOTICE_OPEN_SUCCESS:
            let noticeStatus = state.CHECKOUT_NOTICE;
            noticeStatus.status = 2
            return Object.assign({}, state, {
                CHECKOUT_NOTICE: noticeStatus
            });
            break;
        case CHECKOUT.CHECKOUT_NOTICE_CLOSE:
            return Object.assign({}, state, {
                CHECKOUT_NOTICE: null
            });
            break;
        case CHECKOUT.CHECKOUT_NOTICE:
            let CheckoutNotice = {
                id: CHECKOUT_NOTICE_ID,
                status: 1
            };
            return Object.assign({}, state, {
                CHECKOUT_NOTICE: CheckoutNotice
            });
            break;
        case CHECKOUT.CHECKOUT_SAVE_ALERT_DATA:
            let saveAlert = {
                status: '0',
                id: CHECKOUT_SAVE_ALERT_DATA_ID,
                type: CHECKOUT_SAVE_ALERT_DATA_TYPE,
                text: CHECKOUT_SAVE_ALERT_DATA_TEXT,
                productName: CHECKOUT_SAVE_ALERT_DATA_NAME,
                productType: CHECKOUT_SAVE_ALERT_DATA_PRODUCT_TYPE,
                quantity: CHECKOUT_SAVE_ALERT_DATA_QUANTITY,
                actionType: CHECKOUT_SAVE_ALERT_DATA_ACTIONTYPE
            };
            return Object.assign({}, state, {
                CHECKOUT_ALERT: saveAlert
            });
            break;
        case CHECKOUT.CHECKOUT_CLOSE_ALERT:
            return Object.assign({}, state, {
                CHECKOUT_ALERT: null
            });
            break;
        case CHECKOUT.CHECKOUT_CARTINFO:
            return Object.assign({}, state, {
                CHECKOUT_CARTINFO
            });
            break;
        case CHECKOUT.CHECKOUT_CARTINFO_BOOKING:
            return Object.assign({}, state, {
                CHECKOUT_CARTINFO_BOOKING
            });
            break;
        case CHECKOUT.SET_CHECKOUT_GIFT:
            return Object.assign({}, state, {
                SET_CHECKOUT_GIFT
            });
            break;
        case CHECKOUT.CHECKOUT_PURCHASED:
            return Object.assign({}, state, {
                CHECKOUT_PURCHASED
            });
            break;
        case CHECKOUT.CHECKOUT_ADDRESS_EXPRESS:
            return Object.assign({}, state, {
                CHECKOUT_ADDRESS_EXPRESS
            });
            break;
        case CHECKOUT.CHECKOUT_ADDRESS_COD:
            return Object.assign({}, state, {
                CHECKOUT_ADDRESS_COD
            });
            break;
        case CHECKOUT.CHECKOUT_DELIVERY_INFO:
            return Object.assign({}, state, {
                CHECKOUT_DELIVERY_INFO
            });
            break;
        case CHECKOUT.CHECKOUT_DELETE_POSITION_FIRST:
            return Object.assign({}, state, {
                CHECKOUT_DELETE_POSITION_FIRST
            });
            break;
        case CHECKOUT.CHECKOUT_DELETE_POSITION_SECOND:
            return Object.assign({}, state, {
                CHECKOUT_DELETE_POSITION_SECOND
            });
            break;
        case CHECKOUT.CHECKOUT_DELETE_POSITION_THIRD:
            return Object.assign({}, state, {
                CHECKOUT_DELETE_POSITION_THIRD
            });
            break;
        case CHECKOUT.CHECKOUT_TAB_ACTIVE:
            CHECKOUT_TAB_ACTIVE_OBJECT = state.CHECKOUT_TAB_LIST;
            CHECKOUT_TAB_ACTIVE_OBJECT.map((data, index) => {
                data.Active = 0;
                if (data.Content == CHECKOUT_TAB_ACTIVE.Content) { data.Active = 1 }
            });
            return Object.assign({}, state, {
                CHECKOUT_TAB_LIST: CHECKOUT_TAB_ACTIVE_OBJECT
            });
            break;
        case CHECKOUT.CHECKOUT_TAB_GUESSYOULIKE:
            CHECKOUT_TAB_LIST_OBJECT = { ID: "GuessYouLike", Content: "猜你喜欢", Position: 0, Active: 1 };
            CHECKOUT_TAB_LIST = [...state.CHECKOUT_TAB_LIST, CHECKOUT_TAB_LIST_OBJECT];
            return Object.assign({}, state, {
                CHECKOUT_TAB_GUESSYOULIKE,
                CHECKOUT_TAB_LIST
            });
            break;

        case CHECKOUT.CHECKOUT_TAB_MYFAVORITE:
            CHECKOUT_TAB_LIST_OBJECT = { ID: "MyFavorite", Content: "我的收藏", Position: 1, Active: 0 };
            CHECKOUT_TAB_LIST = [...state.CHECKOUT_TAB_LIST, CHECKOUT_TAB_LIST_OBJECT];
            return Object.assign({}, state, {
                CHECKOUT_TAB_MYFAVORITE,
                CHECKOUT_TAB_LIST
            });
            break;
        case CHECKOUT.CHECKOUT_TAB_MYBROWSERHISTORY:
            CHECKOUT_TAB_LIST_OBJECT = { ID: "MyBrowserHistory", Content: "浏览记录", Position: 2, Active: 0 };
            CHECKOUT_TAB_LIST = [...state.CHECKOUT_TAB_LIST, CHECKOUT_TAB_LIST_OBJECT];
            return Object.assign({}, state, {
                CHECKOUT_TAB_MYBROWSERHISTORY,
                CHECKOUT_TAB_LIST
            });
            break;
        case CHECKOUT.CHECKOUT_GET:
            return Object.assign({}, state, {
                CHECKOUT_PUBLIC_DATA
            });
            break;
        case CHECKOUT.CHECKOUT_DEFAULT_ADDRESS:
            return Object.assign({}, state, {
                CHECKOUT_DEFAULT_ADDRESS
            });
            break;
        case CHECKOUT.CHECKOUT_ORDER_ID:
            return Object.assign({}, state, {
                CHECKOUT_ORDER_ID
            });
            break;
        case CHECKOUT.CHECKOUT_INFORMATION:
            return Object.assign({}, state, {
                CHECKOUT_INFORMATION
            });
            break;
        case CHECKOUT.CHECKOUT_CHANGE_PAYMENT:
            return Object.assign({}, state, {
                CHECKOUT_CHANGE_PAYMENT
            });
            break;
        case CHECKOUT.CHECKOUT_CHANGE_RECEIVING:
            return Object.assign({}, state, {
                CHECKOUT_CHANGE_RECEIVING
            });
            break;
        case CHECKOUT.CHECKOUT_PAY_LINK:
            return Object.assign({}, state, {
                CHECKOUT_PAY_LINK
            });
            break;
        case CHECKOUT.CHECKOUT_SILK_CARD_LIST:
            return Object.assign({}, state, {
                CHECKOUT_SILK_CARD_LIST
            });
            break;
        case CHECKOUT.CHECKOUT_URL_PARMTER:
            return Object.assign({}, state, {
                CHECKOUT_URL_PARMTER
            });
            break;
        case CHECKOUT.GETOPTIONALGIFT:
            return Object.assign({}, state, {
                GETOPTIONALGIFT
            });
        case CHECKOUT.CHECKOUT_INVOICE_STATUS:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_STATUS
            })
        case CHECKOUT.CHECKOUT_INVOICE_DEFAULTTITLE:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_DEFAULTTITLE
            })
        case CHECKOUT.CHECKOUT_INVOICE_INDIVIDUAL_SAVE:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_INDIVIDUAL_SAVE
            })
        case CHECKOUT.CHECKOUT_INVOICE_ENTERPRISE_SAVE:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_ENTERPRISE_SAVE
            })
        case CHECKOUT.CHECKOUT_INVOICE_ENTERPRISE_OPEN:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_ENTERPRISE_OPEN
            })
        case CHECKOUT.CHECKOUT_INVOICE_TITLEID:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_TITLEID
            })
        case CHECKOUT.CHECKOUT_INVOICE_DATA:
            return Object.assign({}, state, {
                CHECKOUT_INVOICE_DATA
            })
        case CHECKOUT.EXTRABUYACTID:
            return Object.assign({}, state, {
                EXTRABUYACTID
            })
        case CHECKOUT.EXTRALBUYSHOWSTATUS:
            return Object.assign({}, state, {
                EXTRALBUYSHOWSTATUS
            })
        case CHECKOUT.EXTRABUYTITLE:
            return Object.assign({}, state, {
                EXTRABUYTITLE
            })
        case CHECKOUT.EXCHANGEPRODUCTLIST:
            return Object.assign({}, state, {
                EXCHANGEPRODUCTLIST
            })
        case CHECKOUT.CART_TIPSMSG:
            return Object.assign({}, state, {
                CART_TIPSMSG
            })
            break;
        case CHECKOUT.DELETEPRODUCTTYPE:
            return Object.assign({}, state, {
                DELETEPRODUCTTYPE
            })
            break;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./common/reducers/checkout.js